import axios, { AxiosError } from "axios";
import domain from './domen'
import { IAuthForm, IAuthResponsFunction } from "../Intarfaces/IAuth";

const sleep = (ms:number) => new Promise(
    resolve => setTimeout(resolve, ms));

export default class AuthAPI{
    
    static async auth(form:IAuthForm):Promise<IAuthResponsFunction>{

        try{
            const response = await axios.post(domain+'/login', form,{
                headers:{
                    "Content-Type":"application/json"
                }
            })

            console.log(response.data);
            
    
            if(response.status===200){
                localStorage.setItem('token',response.data.token)
                return {status:200, message:"Авторизация прошла успешно"} as IAuthResponsFunction
            }

            return {status:response.status, message:"Ошибка"} as IAuthResponsFunction
        }
        catch(error){

            let er = error as AxiosError<{detail:string}>
            console.log(error);
            
            
            if(er.status===401){
                return {status:401, message:"Неверный E-mail или пароль"} as IAuthResponsFunction
            }

            return {status:0, message:"Ошибка"} as IAuthResponsFunction
            
        }
    }

}